/**
 * TCS — re-measure the header menu fold once web fonts have loaded.
 *
 * WHY THIS EXISTS
 * Horizon's <overflow-list> decides which top-level items fold into "More" by
 * measuring the rendered item widths, and re-measures only when its own box
 * resizes or its children change. The storefront's Gilroy faces can finish
 * loading AFTER that measurement; the items then change width inside a list
 * whose box does not resize, so a fold computed with fallback-font metrics
 * can stick. Measured 2026-09-17 on the preview theme at a 1440px viewport:
 * COLLECTIONS folded at 518ms while `document.fonts.status` was "loading",
 * and on one load it stayed in More although all nine items fit.
 *
 * HOW IT WORKS — and why not a core edit
 * <overflow-list> listens for a public `reflow` CustomEvent and re-runs its own
 * reflow. We dispatch it when fonts finish loading; Horizon still decides the
 * fold. Behaviour only, no styling, no Horizon file touched.
 *
 * COUPLING NOTE: assets/overflow-list.js, Horizon 4.1.3, `reflow` CustomEvent
 * with `event.detail.lastVisibleElement` (scripts/tests/tcs-mega-menu-panels.test.mjs
 * re-verifies it).
 */
(() => {
  const reflowHeaderMenus = () => {
    for (const list of document.querySelectorAll('header-menu overflow-list')) {
      list.dispatchEvent(new CustomEvent('reflow', { detail: {} }));
    }
  };

  if (document.fonts) {
    document.fonts.ready.then(reflowHeaderMenus);
    document.fonts.addEventListener('loadingdone', reflowHeaderMenus);
  }
})();
